// Shipment.js
class Shipment {
    constructor() {
        this.DBIndex = "001";
        this.ShipmentNumber = "";
        this.ConsigneeName = "";
        this.ConsigneeAddress1 = "";
        this.ConsigneeAddress2 = "";
        this.ConsigneeAddress3 = "";
        this.ConsigneePostalCode = "";
        this.ConsigneeTown = "";
        this.Status = "";
        this.Comments = "";
        this.SignedName = "";
        this.ShipmentType = "";
        this.ValidationDate = "";
        this.Signature = "";
        this.FreePictureList = ["","",""];
        this.PhoneNumber = "";
        this.Customer = "";
        this.DCSFileName = "";
        this.CabScanned = false;
        this.AddressDefined = false;
        this.Sent = false;
        this.Error = "";
        this.Email = "";
        this.DeviceID = "";
        this.Language = "";

        this.DCS = {
            FileName: '',
            FileFullPath: ''
        };

        this.Geolocation = {
            latitude: '',
            longitude: '',
            date: '',
            accuracy: ''
        };
    }

    getDeliveryLabel() {
        var astrLabel = this.ConsigneeName + "\n";
        astrLabel += this.ConsigneeAddress1 + "\n";
        if (this.ConsigneeAddress2) astrLabel += this.ConsigneeAddress2 + "\n";
        if (this.ConsigneeAddress3) astrLabel += this.ConsigneeAddress3 + "\n";
        if (this.ConsigneePostalCode) astrLabel += this.ConsigneePostalCode + " ";
        astrLabel += this.ConsigneeTown;
        return astrLabel;
    }

    /**
     * Get shipment address (for geolocation)
     */
    getAddress() {
        var astrAddress = "";
        if (this.ConsigneeAddress1 !== "") astrAddress += this.ConsigneeAddress1 + " ";
        if (this.ConsigneeAddress2 !== "") astrAddress += this.ConsigneeAddress2 + " ";
        if (this.ConsigneeAddress3 !== "") astrAddress += this.ConsigneeAddress3 + " ";
        if (this.ConsigneePostalCode !== "") astrAddress += this.ConsigneePostalCode + " ";
        if (this.ConsigneeTown !== "") astrAddress += this.ConsigneeTown + " ";
        return astrAddress;
    };

    /**
     * Check if a signature picture exists
     */
    signatureExits() {
        return (this.Signature !== null && this.Signature !== "");
    };

    /**
     * Check if a free picture exists at the given index
     */
    freePictureExits(theiIndex) {
        return (this.FreePictureList !== null && this.FreePictureList[theiIndex] !== null && this.FreePictureList[theiIndex] !== "");
    };

    /**
     * Get the free picture at the given index
     */
    getFreePicture(theiIndex) {
        return ((this.FreePictureList !== null && this.FreePictureList[theiIndex] !== null) ? this.FreePictureList[theiIndex] : "");
    };

    /**
     * Get number of free pictures
     */
    getNbFreePictures() {
        var aiNbFreePictures = 0;
        for (var aiCpt = 0; aiCpt < this.FreePictureList.length; aiCpt++) {
            if (this.FreePictureList[aiCpt] !== null && this.FreePictureList[aiCpt] !== "") {
                aiNbFreePictures++;
            }
        }
        return aiNbFreePictures;
    };
}

export default Shipment;
